const preferencesTypes = {

  index: {
    request: "PREFERENCES_INDEX_REQUEST",
    success: "PREFERENCES_INDEX_SUCCESS",
    failure: "PREFERENCES_INDEX_FAILURE"
  },

  update: {
    request: "UPDATE_PREFERENCE_REQUEST",
    success: "UPDATE_PREFERENCE_SUCCESS",
    failure: "UPDATE_PREFERENCE_FAILURE"
  },

  reset: "RESET_PREFERENCES",
  
  reset_errors: "RESET_PREFERENCE_ERRORS"

}

export default preferencesTypes



// WEBPACK FOOTER //
// ./src/js/constants/preferencesTypes.js